import { atom } from "jotai";

export const menuOpenAtom = atom(false);
export const activeSectionAtom = atom("home");
